import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import { fetchcart } from "../../../ApiService/cart-api/cartapi";
import { removecartitem } from "../../../ApiService/removecart/removecartapi";
import toast from "react-hot-toast";
import BottomNav from "../../../components/bottomnav";
const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

export default function Shopcart() {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedItems, setSelectedItems] = useState(new Set());
  const navigate = useNavigate();

  const customer_id = localStorage.getItem("customer_id") || 1;

  useEffect(() => {
    loadCart();
  }, [customer_id]);

  const loadCart = async () => {
    try {
      setLoading(true);
      const data = await fetchcart(customer_id);
      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.cart_items)
        ? data.cart_items
        : [];
      setCartItems(items);
      setSelectedItems(new Set());
    } catch (err) {
      console.error("Error fetching cart:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (item_id) => {
    try {
      await removecartitem(customer_id, item_id);
      toast.success("Remove item from the cart", {
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
      setCartItems((prev) => prev.filter((item) => item.item_id !== item_id));
      if (selectedItems.has(item_id)) {
        const newSelected = new Set(selectedItems);
        newSelected.delete(item_id);
        setSelectedItems(newSelected);
      }
    } catch (error) {
      console.error("Error removing item:", error);
      toast.error("Failed to remove item from cart.", {
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });
    }
  };

  const handleSelectItem = (item_id) => {
    const newSelected = new Set(selectedItems);
    if (newSelected.has(item_id)) {
      newSelected.delete(item_id);
    } else {
      newSelected.add(item_id);
    }
    setSelectedItems(newSelected);
  };

  const handleSelectAll = () => {
    if (selectedItems.size === cartItems.length) {
      setSelectedItems(new Set());
    } else {
      const allItemIds = cartItems.map((item) => item.item_id).filter(Boolean);
      setSelectedItems(new Set(allItemIds));
    }
  };

  const totalPrice = cartItems.reduce((total, item) => {
    const variant = item.variant || {};
    const price =
      variant?.sizes?.[0]?.price?.discounted ||
      variant?.sizes?.[0]?.price?.mrp ||
      0;
    return total + price * (item.quantity || 1);
  }, 0);

  const selectedTotal = cartItems
    .filter((item) => selectedItems.has(item.item_id))
    .reduce((total, item) => {
      const variant = item.variant || {};
      const price =
        variant?.sizes?.[0]?.price?.discounted ||
        variant?.sizes?.[0]?.price?.mrp ||
        0;
      return total + price * (item.quantity || 1);
    }, 0);

 const handleCheckout = () => {
  const selectedCartItems = cartItems.filter((item) =>
    selectedItems.has(item.item_id)
  );
  const hasRegular = selectedCartItems.some(
    (item) => item.is_product === true || item.is_product === "true"
  );
  const hasCustomizable = selectedCartItems.some(
    (item) => !(item.is_product === true || item.is_product === "true")
  );

  if (selectedCartItems.length === 0) {
    toast.error("Please select at least one item to proceed to checkout.", {
      style: {
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    return;
  }

  if (hasRegular && hasCustomizable) {
    toast.error(
      "You have selected both regular and customizable products. Please select only one type.",
      {
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      }
    );
    return;
  }

  // Pass product details based on type
  const selectedProductDetails = selectedCartItems.map((item) => {
    // For regular products
    if (item.is_product === true || item.is_product === "true") {
      const variant = item.variant || {};
      const sizeInfo = variant.sizes?.[0] || {};
      
      return {
        item_id: item.item_id,
        is_item:item.product_id === null ? false : true,
        quantity: item.quantity,
        product_id: item.product_id,
        product_name: item.product_name,
        brand_id: item.brand_id,
        brand_name: item.brand_name,
        category_id: item.category_id,
        category_name: item.category_name,
        sub_category_id: item.sub_category_id,
        sub_category_name: item.sub_category_name,
        is_product: item.is_product,
        variant: item.variant,
        // Extract specific details from variant
        price: sizeInfo.price?.discounted || sizeInfo.price?.mrp || 0,
        size: sizeInfo.size || "N/A",
        sku: sizeInfo.sku || "",
        gender: variant.gender || "",
        fabric: variant.fabric || "",
        color: variant.color || "",
        color_code: variant.color_code || "",
        images: variant.images || []
      };
    } 
    // For customizable products
    else {
      const variant = item.variant || {};
      const sizeInfo = variant.sizes?.[0] || {};
      
      return {
        item_id: item.item_id,
        is_item:item.product_id === null ? false : true,
        quantity: item.quantity,
        product_id: item.product_id,
        product_name: item.product_name || "Custom Product",
        brand_id: item.brand_id,
        brand_name: item.brand_name,
        category_id: item.category_id,
        category_name: item.category_name,
        sub_category_id: item.sub_category_id,
        sub_category_name: item.sub_category_name,
        custom_size: item.custom_size,
        is_product: item.is_product,
        logos: item.logos || [],
        reference_image: item.reference_image,
        custom_text: item.custom_text,
        sku_code: item.sku_code,
        variant: item.variant,
        // For custom products, prioritize custom fields
        price: sizeInfo.price?.discounted || sizeInfo.price?.mrp || 0,
        size: item.custom_size || sizeInfo.size || "N/A",
        sku: item.sku_code || sizeInfo.sku || "",
        gender: variant.gender || "",
        fabric: variant.fabric || "",
        color: variant.color || "",
        color_code: variant.color_code || "",
        images: variant.images || []
      };
    }
  });

  // Navigate to checkout page with selected product details
  navigate("/checkout", {
    state: {
      locationType: "cart",
      selectedItems: selectedProductDetails,
    },
  });

  toast.success("Proceeding to checkout...", {
    style: { borderRadius: "10px", background: "#333", color: "#fff" },
  });
};

  if (loading) return <p className="text-center pt-20">Loading cart...</p>;
  if (error) return <p className="text-center pt-20 text-red-500">{error}</p>;

  return (
    <>
      <Navbar />
      <div className="container mx-auto pt-24 pb-16 px-4">
        <h2 className="text-3xl font-bold mb-8 text-gray-800">Shopping Cart</h2>

        {!cartItems || cartItems.length === 0 ? (
          <div className="bg-white rounded-xl shadow-sm p-12 text-center">
            <div className="text-gray-400 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>
            <h3 className="text-xl font-medium text-gray-700 mb-2">
              Your cart is empty
            </h3>
            <p className="text-gray-500 max-w-md mx-auto">
              Looks like you haven't added any items to your cart yet.
            </p>
          </div>
        ) : (
          <>
            <div className="flex items-center mb-4 p-3 bg-gray-50 rounded-lg">
              <input
                type="checkbox"
                id="selectAll"
                checked={
                  selectedItems.size === cartItems.length &&
                  cartItems.length > 0
                }
                onChange={handleSelectAll}
                className="h-5 w-5 text-green-600 rounded focus:ring-green-500"
              />
              <label
                htmlFor="selectAll"
                className="ml-3 text-gray-700 font-medium"
              >
                Select All Items
              </label>
            </div>

            <div className="grid gap-6">
              {Array.isArray(cartItems) &&
                cartItems.map((item, index) => {
                  const item_id = item.item_id || "";
                  const variant = item.variant || {};
                  const isProduct =
                    item.is_product === true || item.is_product === "true";
                  const isCustomizable = !isProduct;

                  let firstImage = "";
                  if (isCustomizable && item.reference_image) {
                    firstImage = `${BASE_MEDIA_URL}${item.reference_image}`;
                  } else if (variant.images?.[0]) {
                    firstImage = `${BASE_MEDIA_URL}${variant.images[0]}`;
                  }

                  const price =
                    variant?.sizes?.[0]?.price?.discounted ||
                    variant?.sizes?.[0]?.price?.mrp ||
                    0;
                  const size =
                    item.custom_size ||
                    variant?.sizes?.[0]?.size ||
                    "N/A";
                  const sku_code = variant?.sizes?.[0]?.sku || item.sku_code || "";
                  const gender = variant.gender
                    ? variant.gender === "Men"
                      ? "M"
                      : variant.gender === "Women"
                      ? "F"
                      : variant.gender
                    : null;
                  const fabric = variant?.fabric || "N/A";
                  const color = variant?.color || null;
                  const color_code = variant?.color_code || null;

                  return (
                    <div
                      key={item_id || index}
                      className="bg-white rounded-xl shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md"
                    >
                      <div className="p-5">
                        <div className="flex flex-col md:flex-row gap-6">
                          <div className="flex items-center justify-center md:justify-start">
                            <input
                              type="checkbox"
                              checked={selectedItems.has(item_id)}
                              onChange={() => handleSelectItem(item_id)}
                              className="h-5 w-5 text-green-600 rounded focus:ring-green-500"
                            />
                          </div>
                          <div className="flex-shrink-0">
                            <img
                              src={firstImage}
                              alt={item.product_name}
                              className="w-full md:w-32 h-32 object-cover rounded-lg border border-gray-200"
                            />
                          </div>
                          <div className="flex-grow">
                            <div className="flex flex-col h-full">
                              <div className="flex justify-between items-start">
                                <div>
                                  <h3 className="text-lg font-bold text-gray-800">
                                    {item.product_name}
                                  </h3>
                                  {item.brand_name && (
                                    <p className="text-sm text-gray-600 mt-1">
                                      Brand:{" "}
                                      <span className="font-medium">
                                        {item.brand_name}
                                      </span>
                                    </p>
                                  )}
                                </div>
                                <span
                                  className={`px-3 py-1 text-xs font-semibold rounded-full ${
                                    isProduct
                                      ? "bg-purple-100 text-purple-800"
                                      : "bg-blue-100 text-blue-800"
                                  }`}
                                >
                                  {isProduct ? "Regular" : "Customize"}
                                </span>
                              </div>
                              <div className="flex flex-wrap gap-3 mt-3">
                                {color && (
                                  <div className="flex items-center">
                                    <span className="text-sm text-gray-500">
                                      Color:
                                    </span>
                                    <span
                                      className="inline-block w-5 h-5 rounded-full border border-gray-300 ml-2"
                                      style={{
                                        backgroundColor: color_code,
                                      }}
                                    ></span>
                                    <span className="text-sm font-medium text-gray-700 ml-1">
                                      {color}
                                    </span>
                                  </div>
                                )}
                                <div className="flex items-center">
                                  <span className="text-sm text-gray-500">
                                    Size:
                                  </span>
                                  <span className="text-sm font-medium text-gray-700 ml-2">
                                    {size}
                                  </span>
                                </div>
                                {gender && (
                                  <div className="flex items-center">
                                    <span className="text-sm text-gray-500">
                                      Gender:
                                    </span>
                                    <span className="text-sm font-medium text-gray-700 ml-2">
                                      {gender}
                                    </span>
                                  </div>
                                )}
                                {fabric !== "N/A" && (
                                  <div className="flex items-center">
                                    <span className="text-sm text-gray-500">
                                      Fabric:
                                    </span>
                                    <span className="text-sm font-medium text-gray-700 ml-2">
                                      {fabric}
                                    </span>
                                  </div>
                                )}
                              </div>
                              {isCustomizable && item.custom_text && (
                                <p className="text-sm text-gray-600 mt-2">
                                  Custom Text:{" "}
                                  <span className="font-medium">
                                    {item.custom_text}
                                  </span>
                                </p>
                              )}
                              <div className="mt-auto pt-3 flex justify-between items-center">
                                <div>
                                  <p className="text-sm text-gray-500">
                                    Quantity: {item.quantity || 1}
                                  </p>
                                  <p className="text-lg font-bold text-gray-800 mt-1">
                                    ₹{price.toLocaleString()}
                                  </p>
                                </div>
                                <button
                                  onClick={() => handleRemove(item_id)}
                                  className="p-2 rounded-full hover:bg-red-50 text-red-500 hover:text-red-700 transition-colors duration-200"
                                  aria-label="Remove item"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>

            <div className="mt-8 bg-white rounded-xl shadow-sm p-6">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <div>
                  <h3 className="text-xl font-bold text-gray-800">
                    Order Summary
                  </h3>
                  <p className="text-lg text-gray-600 mt-1">
                    Total: ₹{totalPrice.toLocaleString()}
                  </p>
                  <p className="text-2xl font-bold text-green-500 mt-1">
                    Selected Total: ₹{selectedTotal.toLocaleString()}
                  </p>
                </div>
                <button
                  onClick={handleCheckout}
                  className="bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-300 w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={selectedItems.size === 0}
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <BottomNav/>
      <Footer />
    </>
  );
}